// Icons

import { createIcon } from "@chakra-ui/react";

export const FilterIcon = createIcon({
  path: <path d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z" fill="transparent" />,
  displayName: "FilterIcon",
});
export const MoreIcon = createIcon({
  path: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        stroke="#5F606D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
        stroke="#5F606D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
        stroke="#5F606D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  displayName: "MoreIcon",
});

export const BellIcon = createIcon({
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.44752 7.96942C6.76186 5.14032 9.15317 3 11.9997 3C14.8462 3 17.2375 5.14032 17.5518 7.96942L17.8036 10.2356C17.8068 10.2645 17.8085 10.279 17.8101 10.2933C17.939 11.417 18.3048 12.5005 18.8832 13.4725C18.8906 13.4849 18.8981 13.4973 18.913 13.5222L19.4911 14.4856C20.0156 15.3599 20.2779 15.797 20.2213 16.1559C20.1836 16.3946 20.0607 16.6117 19.8753 16.7668C19.5968 17 19.087 17 18.0674 17H5.93191C4.91236 17 4.40259 17 4.12401 16.7668C3.93865 16.6117 3.81576 16.3946 3.77809 16.1559C3.72147 15.797 3.98374 15.3599 4.5083 14.4856L5.08633 13.5222C5.10129 13.4973 5.10876 13.4849 5.11612 13.4725C5.69456 12.5005 6.06032 11.417 6.18926 10.2933C6.1909 10.279 6.19251 10.2645 6.19572 10.2356L6.44752 7.96942Z"
        fill="#5F606D"
      />
      <path
        d="M8.99968 17C8.99968 17.394 9.07727 17.7841 9.22804 18.1481C9.3788 18.512 9.59978 18.8427 9.87836 19.1213C10.1569 19.3999 10.4876 19.6209 10.8516 19.7716C11.2156 19.9224 11.6057 20 11.9997 20C12.3936 20 12.7838 19.9224 13.1477 19.7716C13.5117 19.6209 13.8424 19.3999 14.121 19.1213C14.3996 18.8427 14.6206 18.512 14.7713 18.1481C14.9221 17.7841 14.9997 17.394 14.9997 17H8.99968Z"
        fill="#5F606D"
      />
    </svg>
  ),
  displayName: "BellIcon",
});

export const WarningIcon = createIcon({
  path: (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 13C11.4477 13 11 12.5523 11 12L11 8C11 7.44771 11.4477 7 12 7C12.5523 7 13 7.44771 13 8L13 12C13 12.5523 12.5523 13 12 13ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15L11.99 15C11.4377 15 10.99 15.4477 10.99 16C10.99 16.5523 11.4377 17 11.99 17L12 17Z"
      fill="var(--graph-orange-bright)"
    />
  ),
  displayName: "WarningIcon",
});

export const EditIcon = createIcon({
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.03589 18C7.1685 18 7.29568 17.9473 7.38945 17.8536L18.678 6.565C18.8655 6.37747 18.9708 6.12316 18.9708 5.858C18.9708 5.59284 18.8655 5.33853 18.678 5.151L15.849 2.322C15.6615 2.13453 15.4072 2.02921 15.142 2.02921C14.8768 2.02921 14.6225 2.13453 14.435 2.322L3.14645 13.6106C3.05268 13.7043 3 13.8315 3 13.9641V17.5C3 17.7761 3.22386 18 3.5 18H7.03589Z"
        fill="#5F606D"
      />
      <path
        d="M4 20H20C20.5523 20 21 20.4477 21 21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21C3 20.4477 3.44772 20 4 20Z"
        fill="#5F606D"
      />
    </svg>
  ),
  displayName: "EditIcon",
});

export const DeleteIcon = createIcon({
  path: (
    <path d="M6.85847 5V1.4C6.85847 1.08174 6.9849 0.776516 7.20994 0.551472C7.43498 0.326428 7.74021 0.2 8.05847 0.2H17.6585C17.9767 0.2 18.282 0.326428 18.507 0.551472C18.732 0.776516 18.8585 1.08174 18.8585 1.4V5H23.6585C24.3212 5 25 5.53726 25 6.2C25 6.86274 24.3212 7.4 23.6585 7.4H22.4585V23C22.4585 23.3183 22.332 23.6235 22.107 23.8485C21.882 24.0736 21.5767 24.2 21.2585 24.2H4.5C4.18174 24.2 3.83498 24.0736 3.60994 23.8485C3.3849 23.6235 3.25847 23.3183 3.25847 23V7.4H2.05847C1.39573 7.4 0.858468 6.86274 0.858468 6.2C0.858468 5.53726 1.39573 5 2.05847 5H6.85847ZM9.25847 2.6V5H16.4585V2.6H9.25847Z" />
  ),
  displayName: "DeleteIcon",
});

export const ShareIcon = createIcon({
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <path d="M13 15C13 14.4477 12.5523 14 12 14H11C9.3596 13.9994 7.75023 14.4471 6.34587 15.2949C5.17356 16.0026 4.18133 16.9665 3.44125 18.1103C3.31345 18.3078 2.99988 18.2353 3 18C3 12.814 6.94728 8.55028 12.0014 8.04923C12.551 7.99475 13 7.55228 13 7V5.08062C13 4.24212 13.9699 3.77595 14.6247 4.29976L22.0239 10.2191C22.5243 10.6195 22.5243 11.3805 22.0239 11.7809L14.6247 17.7002C13.9699 18.2241 13 17.7579 13 16.9194V15Z" />
    </svg>
  ),
  displayName: "ShareIcon",
});

export const ExchangeIcon = createIcon({
  path: (
    <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 9H8V11H17L12 6V9ZM7 13L12 18V15H16V13H7Z" />
  ),
  displayName: "ExchangeIcon",
});

export const SuitcaseIcon = createIcon({
  path: (
    <path d="M15 3C15.552 3 16 3.448 16 4V6H21C21.552 6 22 6.448 22 7V20C22 20.552 21.552 21 21 21H3C2.448 21 2 20.552 2 20V7C2 6.448 2.448 6 3 6H8V4C8 3.448 8.448 3 9 3H15ZM8 8H6V19H8V8ZM18 8H16V19H18V8ZM14 5H10V6H14V5Z" />
  ),
  displayName: "SuitcaseIcon",
});
export const PinIcon = createIcon({
  path: (
    <path d="M11 17.938C8.98271 17.6813 7.13885 16.6661 5.84319 15.0988C4.54752 13.5314 3.89728 11.5295 4.02462 9.49997C4.15196 7.47041 5.04733 5.56549 6.52874 4.17238C8.01016 2.77927 9.96645 2.00252 12 2C14.036 1.99849 15.9961 2.77334 17.4807 4.16668C18.9653 5.56002 19.8628 7.467 19.9903 9.49904C20.1178 11.5311 19.4657 13.5353 18.1669 15.1033C16.868 16.6712 15.0203 17.685 13 17.938V20.012C16.946 20.104 20 20.735 20 21.5C20 22.328 16.418 23 12 23C7.582 23 4 22.328 4 21.5C4 20.735 7.054 20.104 11 20.012V17.938ZM12 12C12.5304 12 13.0391 11.7893 13.4142 11.4142C13.7893 11.0391 14 10.5304 14 10C14 9.46957 13.7893 8.96086 13.4142 8.58579C13.0391 8.21072 12.5304 8 12 8C11.4696 8 10.9609 8.21072 10.5858 8.58579C10.2107 8.96086 10 9.46957 10 10C10 10.5304 10.2107 11.0391 10.5858 11.4142C10.9609 11.7893 11.4696 12 12 12Z" />
  ),
  displayName: "PinIcon",
});

export const NoteIcon = createIcon({
  path: (
    <path d="M10.7676 9.91667L10.6847 9.92162C10.5266 9.94027 10.3794 10.0116 10.2668 10.1242C10.1542 10.2368 10.0828 10.384 10.0642 10.5421L10.0592 10.625V14.875H2.97449C2.78751 14.8754 2.60802 14.8015 2.47547 14.6696C2.34291 14.5377 2.26814 14.3586 2.26758 14.1716V2.82837C2.26758 2.44021 2.58279 2.125 2.97095 2.125H14.3142C14.7024 2.125 15.0176 2.44163 15.0176 2.83263V9.91667H10.7676ZM15.0176 11.3333L11.4759 14.8729V11.3333H15.0176Z" />
  ),
  displayName: "NoteIcon",
});

export const CollapseIcon = createIcon({
  path: (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_502_12853)">
        <path
          d="M16.0919 6.15074L19.6066 2.63602L21.364 4.39338L17.8493 7.9081L20.4853 10.5441H13.4559V3.5147L16.0919 6.15074Z"
          fill="#5F606D"
        />
        <path
          d="M7.90808 17.8493L4.39337 21.364L2.63601 19.6066L6.15073 16.0919L3.51469 13.4559H10.5441V20.4853L7.90808 17.8493Z"
          fill="#5F606D"
        />
      </g>
    </svg>
  ),
  displayName: "CollapseIcon",
});

export const AddWidgetStroke = createIcon({
  path: (
    <svg>
      <path
        d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
        fill="transparent"
      />
      <path d="M12 8V16" />
      <path d="M8 12H16" />
    </svg>
  ),
  displayName: "AddWidgetStroke",
});

export const ChevronDown = createIcon({
  path: <path d="M6 9L12 15L18 9" stroke="var(--light-gray)" />,
  displayName: "ChevronDown",
});

export const FileUpload = createIcon({
  path: (
    <path
      d="M16 2L21 7V21.008C20.9997 21.2712 20.895 21.5235 20.7088 21.7095C20.5226 21.8955 20.2702 22 20.007 22H3.993C3.73038 21.9982 3.47902 21.8931 3.29322 21.7075C3.10742 21.5219 3.00209 21.2706 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16ZM13 12H16L12 8L8 12H11V16H13V12Z"
      stroke="var(--light-gray)"
      fill="transparent"
    />
  ),
  displayName: "FileUpload",
});

export const ChevronLeft = createIcon({
  path: (
    <path
      d="M12.5 15L7.5 10L12.5 5"
      stroke="var(--light-gray)"
      fill="transparent"
    />
  ),
  displayName: "ChevronLeft",
});

export const ChevronRight = createIcon({
  path: (
    <path d="M6 12L10 8L6 4" stroke="var(--light-gray)" fill="transparent" />
  ),
  displayName: "ChevronRight",
});

export const CloseIcon = createIcon({
  path: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5L5 15"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 5L15 15"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  displayName: "CloseIcon",
});

export const ChevronUp = createIcon({
  path: <path d="M18 15L12 9L6 15" stroke="var(--light-gray)" />,
  displayName: "ChevronUp",
});

export const BellNotified = createIcon({
  path: (
    <svg>
      <path d="M13.7942 3.29494C13.2297 3.10345 12.6259 3 12 3C9.15354 3 6.76223 5.14032 6.44789 7.96942L6.19608 10.2356L6.18963 10.2933C6.06068 11.417 5.69492 12.5005 5.11649 13.4725L5.0867 13.5222L4.50866 14.4856C3.98411 15.3599 3.72183 15.797 3.77845 16.1559C3.81613 16.3946 3.93902 16.6117 4.12438 16.7668C4.40295 17 4.91273 17 5.93227 17H18.0678C19.0874 17 19.5971 17 19.8757 16.7668C20.0611 16.6117 20.184 16.3946 20.2216 16.1559C20.2783 15.797 20.016 15.3599 19.4914 14.4856L18.9134 13.5222L18.8836 13.4725C18.4274 12.7059 18.1034 11.8698 17.9237 10.9994C15.1975 10.9586 13 8.73592 13 6C13 5.00331 13.2917 4.07473 13.7942 3.29494ZM16.2741 4.98883C16.0999 5.28551 16 5.63109 16 6C16 6.94979 16.6621 7.74494 17.5499 7.94914C17.4205 6.82135 16.9609 5.80382 16.2741 4.98883Z" />
      <path d="M9 17C9 17.394 9.0776 17.7841 9.22836 18.1481C9.37913 18.512 9.6001 18.8427 9.87868 19.1213C10.1573 19.3999 10.488 19.6209 10.8519 19.7716C11.2159 19.9224 11.606 20 12 20C12.394 20 12.7841 19.9224 13.1481 19.7716C13.512 19.6209 13.8427 19.3999 14.1213 19.1213C14.3999 18.8427 14.6209 18.512 14.7716 18.1481C14.9224 17.7841 15 17.394 15 17L12 17H9Z" />
      <circle cx="18" cy="6" r="2.5" fill="#2595FD" stroke="#2595FD" />
    </svg>
  ),
  displayName: "BellNotified",
});

export const Bell = createIcon({
  path: (
    <svg>
      <path d="M13.7942 3.29494C13.2297 3.10345 12.6259 3 12 3C9.15354 3 6.76223 5.14032 6.44789 7.96942L6.19608 10.2356L6.18963 10.2933C6.06068 11.417 5.69492 12.5005 5.11649 13.4725L5.0867 13.5222L4.50866 14.4856C3.98411 15.3599 3.72183 15.797 3.77845 16.1559C3.81613 16.3946 3.93902 16.6117 4.12438 16.7668C4.40295 17 4.91273 17 5.93227 17H18.0678C19.0874 17 19.5971 17 19.8757 16.7668C20.0611 16.6117 20.184 16.3946 20.2216 16.1559C20.2783 15.797 20.016 15.3599 19.4914 14.4856L18.9134 13.5222L18.8836 13.4725C18.4274 12.7059 18.1034 11.8698 17.9237 10.9994C15.1975 10.9586 13 8.73592 13 6C13 5.00331 13.2917 4.07473 13.7942 3.29494ZM16.2741 4.98883C16.0999 5.28551 16 5.63109 16 6C16 6.94979 16.6621 7.74494 17.5499 7.94914C17.4205 6.82135 16.9609 5.80382 16.2741 4.98883Z" />
      <path d="M9 17C9 17.394 9.0776 17.7841 9.22836 18.1481C9.37913 18.512 9.6001 18.8427 9.87868 19.1213C10.1573 19.3999 10.488 19.6209 10.8519 19.7716C11.2159 19.9224 11.606 20 12 20C12.394 20 12.7841 19.9224 13.1481 19.7716C13.512 19.6209 13.8427 19.3999 14.1213 19.1213C14.3999 18.8427 14.6209 18.512 14.7716 18.1481C14.9224 17.7841 15 17.394 15 17L12 17H9Z" />
      <circle cx="18" cy="6" r="2.5" />
    </svg>
  ),
  displayName: "Bell",
});

export const CheckIcon = createIcon({
  path: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.3333 15.9998C29.3333 23.3636 23.3638 29.3332 16 29.3332C8.6362 29.3332 2.66667 23.3636 2.66667 15.9998C2.66667 8.63604 8.6362 2.6665 16 2.6665C23.3638 2.6665 29.3333 8.63604 29.3333 15.9998ZM23.3628 12.7177C23.7593 12.3333 23.769 11.7002 23.3846 11.3037C23.0001 10.9072 22.367 10.8975 21.9705 11.2819L14.4167 18.6069L11.3628 15.6456C10.9663 15.2611 10.3332 15.2708 9.94877 15.6673C9.5643 16.0638 9.57404 16.6969 9.97052 17.0814L13.7205 20.7177C14.1084 21.0939 14.7249 21.0939 15.1128 20.7177L23.3628 12.7177Z"
      />
    </svg>
  ),
  displayName: "CheckIcon",
});

export const MenuLeft = createIcon({
  path: (
    <svg>
      <path d="M14.5716 22.2857L9.42871 12L14.5716 1.71429" />
    </svg>
  ),
  displayName: "MenuLeft",
});

export const InfoStroke = createIcon({
  path: (
    <svg>
      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" />
      <path d="M12 16V12" />
      <path d="M12 8H12.01" />
    </svg>
  ),
  displayName: "InfoStroke",
});
export const PlusIcon = createIcon({
  path: (
    <svg>
      <path d="M12 5V19" />
      <path d="M5 12H19" />
    </svg>
  ),
  displayName: "PlusIcon",
});
export const TriangleUp = createIcon({
  path: (
    <svg>
      <path d="M10.3633 4.85092L2.25653 17.3485C2.08938 17.6158 2.00094 17.9188 2.00001 18.2275C1.99907 18.5361 2.08567 18.8396 2.25119 19.1078C2.41671 19.3759 2.65538 19.5994 2.94346 19.7559C3.23153 19.9125 3.55897 19.9966 3.8932 20H20.1068C20.441 19.9966 20.7685 19.9125 21.0565 19.7559C21.3446 19.5994 21.5833 19.3759 21.7488 19.1078C21.9143 18.8396 22.0009 18.5361 22 18.2275C21.9991 17.9188 21.9106 17.6158 21.7435 17.3485L13.6367 4.85092C13.466 4.59116 13.2258 4.3764 12.9391 4.22735C12.6524 4.0783 12.329 4 12 4C11.671 4 11.3476 4.0783 11.0609 4.22735C10.7742 4.3764 10.534 4.59116 10.3633 4.85092Z" />
    </svg>
  ),
  displayName: "TriangleUp",
});
export const TriangleDown = createIcon({
  path: (
    <svg>
      <path d="M10.3633 19.1491L2.25653 6.65153C2.08938 6.38424 2.00094 6.08119 2.00001 5.77253C1.99907 5.46388 2.08567 5.16037 2.25119 4.89222C2.41671 4.62406 2.65538 4.40061 2.94346 4.24407C3.23153 4.08754 3.55897 4.00339 3.8932 4H20.1068C20.441 4.00339 20.7685 4.08754 21.0565 4.24407C21.3446 4.40061 21.5833 4.62406 21.7488 4.89222C21.9143 5.16037 22.0009 5.46388 22 5.77253C21.9991 6.08119 21.9106 6.38424 21.7435 6.65153L13.6367 19.1491C13.466 19.4088 13.2258 19.6236 12.9391 19.7727C12.6524 19.9217 12.329 20 12 20C11.671 20 11.3476 19.9217 11.0609 19.7727C10.7742 19.6236 10.534 19.4088 10.3633 19.1491Z" />
    </svg>
  ),
  displayName: "TriangleDown",
});

export const InfoFill = createIcon({
  path: (
    <svg>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11ZM12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9H12.01C12.5623 9 13.01 8.55228 13.01 8C13.01 7.44772 12.5623 7 12.01 7H12Z"
      />
    </svg>
  ),
  displayName: "InfoFill",
});

export const MoveIcon = createIcon({
  path: (
    <svg>
      <path d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" />
      <path d="M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z" />
      <path d="M19 17C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15C18.4477 15 18 15.4477 18 16C18 16.5523 18.4477 17 19 17Z" />
      <path d="M19 9C19.5523 9 20 8.55228 20 8C20 7.44772 19.5523 7 19 7C18.4477 7 18 7.44772 18 8C18 8.55228 18.4477 9 19 9Z" />
      <path d="M5 17C5.55228 17 6 16.5523 6 16C6 15.4477 5.55228 15 5 15C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17Z" />
      <path d="M5 9C5.55228 9 6 8.55228 6 8C6 7.44772 5.55228 7 5 7C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9Z" />
    </svg>
  ),
  displayName: "MoveIcon",
});

export const RightArrowIcon = createIcon({
  path: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 18L15 12L9 6"
        stroke-width="1px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  displayName: "RightArrowIcon",
});

export const LeftArrowIcon = createIcon({
  path: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 18L9 12L15 6"
        stroke-width="1px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  displayName: "LeftArrowIcon",
});

export const Search = createIcon({
  path: (
    <svg>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20L17 17" />
    </svg>
  ),
  displayName: "Search",
});

export const CalendarIcon = createIcon({
  path: (
    <svg>
      <path d="M9 11H7V13H9V11ZM13 11H11V13H13V11ZM17 11H15V13H17V11ZM19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20Z" />
      <path d="M7 16H9V18H7V16Z" />
      <path d="M11 16H13V18H11V16Z" />
      <path d="M15 16H17V18H15V16Z" />
    </svg>
  ),
  displayName: "Calendar",
});
